import { Expose, Type } from "class-transformer";
import { IsArray, IsNumber, ValidateNested } from "class-validator";
import { AchievementEntity } from "../../entity";

export class GetAllAchievementDTO {
  @Expose()
  @ValidateNested()
  @IsArray()
  @Type(() => AchievementEntity)
  data!: AchievementEntity[];

  @Expose()
  @IsNumber()
  count!: number;

  @Expose()
  @IsNumber()
  page!: number;

  @Expose()
  @IsNumber()
  pageSize!: number;
}
